module.exports = __webpack_public_path__ + "img/1.3fdb55e0.jpg";